import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
// Escapes every special character used in any way in JS regexes,
// to avoid user strings causing actual code-stops-working errors
// from invalid regex (it also prevents a couple types of slightly
// incorrect matches). See UTs for the various edge cases this catches
// See also https://regex101.com/r/pyPMGC/3 for some explanation/examples
const escapeSpecialChars = str => str.replace(/(\.|\+|\*|\{|\}|\[|\]|\(|\)|\\|\||\?|\^|\$|=|!|>|<|:|,)/g, '\\$1');

// Trims any leading/trailing whitespace (which if present causes false matching on the entire string) and replaces any other whitespace with |
const replaceSpaces = str => str.trim().replace(/\s+/g, '|');
const getTextChunks = (fullText, textToHighlight) => {
  const escapedString = escapeSpecialChars(textToHighlight);
  const substringRegex = new RegExp(`(${replaceSpaces(escapedString)})`, 'gi');
  if (!substringRegex.test(fullText)) {
    return [{
      text: fullText,
      shouldHighlight: false,
      key: ''
    }];
  }
  // The split method has this neat functionality where if your regex has
  // a capturing group (which is the parentheses surrounding the regex being
  // created), it includes the matches in the resulting array instead of just
  // getting rid of them. So if you look at the string "Gmail (gmail.com)",
  // string.split(/ail/) would produce the array ['Gm', ' (gm', '.com)'],
  // but string.split(/(ail)/) gives us ['Gm', 'ail', ' (gm', 'ail', '.com)'].
  // This lets us just map over the chunks at the end and determine whether
  // it should be highlighted based on whether it matches textToHighlight
  // See also https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/split#splitting_with_a_regexp_to_include_parts_of_the_separator_in_the_result
  const chunks = fullText ? fullText.split(substringRegex) : [];
  return chunks.map((chunk, idx) => {
    const shouldHighlight = substringRegex.test(chunk);
    return {
      key: chunk + idx,
      text: chunk,
      shouldHighlight
    };
  });
};
export const SubstringHighlighter = ({
  fullText,
  textToHighlight
}) => {
  if (!textToHighlight) return /*#__PURE__*/_jsx("span", {
    children: fullText
  });
  return /*#__PURE__*/_jsx(_Fragment, {
    children: getTextChunks(fullText, textToHighlight).map(({
      key,
      text,
      shouldHighlight
    }, index) => shouldHighlight && key.length > 0 ? /*#__PURE__*/_jsx("b", {
      "data-test-id": "substring-highlighter",
      children: text
    }, key) : /*#__PURE__*/_jsx("span", {
      children: text
    }, index))
  });
};